import { Popover, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useMemo, useRef } from "react";
import { FileWithPath } from "react-dropzone";

import { FileResult } from "../../graphql/generated";
import ActionIcon from "../ActionIcon/ActionIcon";
import SvgClose from "../Icons/Close";
import SvgDownload from "../Icons/Download";
import { useStyles } from "./DownloadFile.styles";

export interface DownloadFileProps {
  file: FileResult | FileWithPath;
  onRemove?: (link: string) => void;
}

export default function DownloadFile({ file, onRemove }: DownloadFileProps) {
  const { classes } = useStyles();

  const nameRef = useRef<HTMLSpanElement>(null);

  const [opened, { close, open }] = useDisclosure(false);

  const nameWidth = nameRef.current?.offsetWidth || 0;
  const fillWidth = nameRef.current?.scrollWidth || 0;

  const displayPopover = fillWidth > nameWidth;

  const filePath = "filePath" in file ? file.filePath : file.path ?? "";
  const fileUrl: string | null = "url" in file ? file.url : null;

  const fileName = useMemo(() => {
    if (!filePath) {
      return;
    }
    const parts = decodeURI(filePath).split("/");
    return parts[parts.length - 1];
  }, [filePath]);

  return (
    <div className={classes.wrapper}>
      <Popover position="top" withinPortal opened={opened && displayPopover}>
        <Popover.Target>
          <div className={classes.nameWrapper}>
            <span
              ref={nameRef}
              className={classes.name}
              onMouseEnter={open}
              onMouseLeave={close}
            >
              {fileName}
            </span>
          </div>
        </Popover.Target>
        <Popover.Dropdown maw={300}>
          <Text size="sm">{fileName}</Text>
        </Popover.Dropdown>
      </Popover>
      <div className={classes.actions}>
        {fileUrl && (
          <ActionIcon href={fileUrl}>
            <SvgDownload />
          </ActionIcon>
        )}

        {onRemove && (
          <ActionIcon variant="error" onClick={() => onRemove(filePath)}>
            <SvgClose />
          </ActionIcon>
        )}
      </div>
    </div>
  );
}
